import { NavLink as RouterLink } from 'react-router-dom';
import { Link } from '@chakra-ui/react';

export const NavLink = ({ children, to, ...props }) => (
  <Link
    as={RouterLink}
    to={to}
    px={3}
    py={1}
    fontSize='md'
    rounded='lg'
    color='white'
    fontWeight='semibold'
    _hover={{
      textDecoration: 'none',
      outline: '2px solid',
      outlineColor: 'teal.400',
      outlineOffset: '2px',
    }}
    _focus={{
      boxShadow: 'none',
      outline: 'none',
    }}
    style={({ isActive }) => ({
      backgroundColor: isActive ? 'white' : 'transparent',
      color: isActive ? 'black' : 'white',
    })}
    {...props}>
    {children}
  </Link>
);
